import React, { useMemo } from 'react';

import { Actions, Action } from '@gogame/components';
import { useGridApiContext } from '@gogame/data-grid';

import { useBatchMarkAsRead } from 'scenes/Gallery/ConversionPages/ConversionGroups/data';

const BatchToolbar = ({ selectedRows }) => {
  const [batchMarkAsReadConcepts] = useBatchMarkAsRead();

  const handleBatchMarkAsRead = (selectedRows) =>
    batchMarkAsReadConcepts(selectedRows);

  return (
    <Actions>
      <Action
        button
        onClick={() => handleBatchMarkAsRead(selectedRows)}
        label={'Mark As Read'}
      />
    </Actions>
  );
};

export default BatchToolbar;

export const BatchToolbarDataGrid = ({ selectedValues, ...props }) => {
  const {
    current: { getRow },
  } = useGridApiContext();

  const selectedRows = useMemo(() => {
    if (!getRow) {
      return selectedValues.map((id) => ({ id }));
    }

    return selectedValues.map((id) => getRow(id));
  }, [selectedValues, getRow]);

  return <BatchToolbar selectedRows={selectedRows} {...props} />;
};
